// ============================================================
// ejemplo.jsx — un puesto de maquillaje de mentiras.
//
// NO es el inventario de nadie: la app arranca VACÍA. Esto se carga sólo si
// el vendedor toca "Ver un ejemplo primero", para curiosear cómo se ve llena.
// Vive aparte porque son datos, no lógica: el día que se borre no hay que
// tocar ningún archivo con código adentro.
// ============================================================

import { fotoDemo } from "./vision.jsx";

export const PRODUCTOS_EJEMPLO = [
  { id: 1, cat: "maq", apodo: "base saniye", nombre: "SANIYE base líquida mate 40 ml",
    precio: 89, costo: 41, emoji: "🧴", minimo: 4, codigo: "6942356701234", foto: fotoDemo("#F2E3D8", "🧴"),
    variantes: [
      { id: 11, etiqueta: "Tono 1 claro", stock: 6, foto: fotoDemo("#F7E9DC", "🟡") },
      { id: 12, etiqueta: "Tono 2 natural", stock: 9, foto: fotoDemo("#EFD9C3", "🟠") },
      { id: 13, etiqueta: "Tono 3 medio", stock: 4, foto: fotoDemo("#DFC0A2", "🟤") },
      { id: 14, etiqueta: "Tono 4 canela", stock: 2, foto: fotoDemo("#C9A279", "🟫") },
    ] },
  { id: 2, cat: "temp", apodo: "pupilentes", nombre: "MAX ONE soft contact lens Halloween",
    precio: 50, costo: 23, emoji: "👁️", minimo: 3, codigo: "6971234500987", foto: fotoDemo("#E4DCF0", "👁️"),
    variantes: [
      { id: 21, etiqueta: "Negro sólido", stock: 5, foto: fotoDemo("#E8E4EC", "⚫") },
      { id: 22, etiqueta: "Verde bruja", stock: 3, foto: fotoDemo("#1C1C1C", "🟢") },
      { id: 23, etiqueta: "Rojo vampiro", stock: 4, foto: fotoDemo("#F0F0F2", "🔴") },
    ] },
  { id: 3, cat: "maq", apodo: "sombras 18", nombre: "SANIYE 18 color eyeshadow kit",
    precio: 40, costo: 19, emoji: "🎨", minimo: 3, stock: 7, codigo: "6942356709876", foto: fotoDemo("#D8DCEF", "🎨") },
  { id: 4, cat: "maq", apodo: "delineador", nombre: "Lápiz delineador de ojos",
    precio: 22, costo: 7, emoji: "✏️", minimo: 20, stock: 64, foto: fotoDemo("#EFEAE2", "✏️") },
  { id: 5, cat: "unas", apodo: "esmalte", nombre: "Esmalte de uñas 15 ml",
    precio: 25, costo: 9, emoji: "💅", minimo: 10, foto: fotoDemo("#F5DCE8", "💅"),
    variantes: [
      { id: 51, etiqueta: "Rojo", stock: 8, foto: fotoDemo("#F7DADA", "🔴") },
      { id: 52, etiqueta: "Rosa", stock: 11, foto: fotoDemo("#F7DAEC", "🌸") },
      { id: 53, etiqueta: "Nude", stock: 6, foto: fotoDemo("#F0E4D8", "🤎") },
      { id: 54, etiqueta: "Negro", stock: 3, foto: fotoDemo("#E2E2E4", "⚫") },
      { id: 55, etiqueta: "Glitter", stock: 5, foto: fotoDemo("#EFEADC", "✨") },
    ] },
  { id: 6, cat: "broch", apodo: "brocha base", nombre: "Brocha para base plana",
    precio: 32, costo: 12, emoji: "🖌️", minimo: 8, stock: 22, foto: fotoDemo("#EDE2D4", "🖌️") },
  { id: 7, cat: "perf", apodo: "perfume chico", nombre: "Perfume de bolsillo 30 ml",
    precio: 45, costo: 18, emoji: "🌸", minimo: 6, foto: fotoDemo("#E8DCF0", "🌸"),
    variantes: [
      { id: 71, etiqueta: "Floral", stock: 7, foto: fotoDemo("#F2DCE8", "🌺") },
      { id: 72, etiqueta: "Dulce", stock: 9, foto: fotoDemo("#F0E4D0", "🍬") },
      { id: 73, etiqueta: "Fresco", stock: 4, foto: fotoDemo("#DCECF0", "🌿") },
    ] },
  { id: 8, cat: "maq", apodo: "rubor", nombre: "Rubor compacto Rosie",
    precio: 35, costo: 14, emoji: "🌷", minimo: 5, stock: 13, foto: fotoDemo("#F5DEE4", "🌷") },
  { id: 9, cat: "piel", apodo: "collagen", nombre: "Crema facial con colágeno",
    precio: 60, costo: 27, emoji: "🫙", minimo: 4, stock: 9, foto: fotoDemo("#DCE8F2", "🫙") },
  { id: 10, cat: "maq", apodo: "corrector", nombre: "Mocallure corrector líquido",
    precio: 28, costo: 11, emoji: "🖊️", minimo: 8, stock: 24, codigo: "6953210044556", foto: fotoDemo("#F2EAE0", "🖊️") },
  { id: 11, cat: "maq", apodo: "labial", nombre: "Labial mate larga duración",
    precio: 30, costo: 11, emoji: "💄", minimo: 12, foto: fotoDemo("#F5D8DC", "💄"),
    variantes: [
      { id: 111, etiqueta: "Rojo", stock: 14, foto: fotoDemo("#F7D6D6", "❤️") },
      { id: 112, etiqueta: "Vino", stock: 8, foto: fotoDemo("#E8D2D8", "🍷") },
      { id: 113, etiqueta: "Nude", stock: 10, foto: fotoDemo("#F0E2D6", "🤎") },
      { id: 114, etiqueta: "Coral", stock: 0, foto: fotoDemo("#F7E0D2", "🧡") },
    ] },
  { id: 12, cat: "acc", apodo: "pestañas", nombre: "Pestañas postizas par",
    precio: 20, costo: 6, emoji: "👁️", minimo: 15, stock: 41, foto: fotoDemo("#E8E2EC", "👁️") },
];
